import { tableConstantsFactory } from './tableConstantsFactory';
const mapConstants = tableConstantsFactory('MAP');
mapConstants.CLUSTER_ITEMS_REQUEST = 'MAP_CLUSTER_ITEMS_REQUEST';
mapConstants.CLUSTER_ITEMS_SUCCESS = 'MAP_CLUSTER_ITEMS_SUCCESS';
mapConstants.CLUSTER_ITEMS_FAILURE = 'MAP_CLUSTER_ITEMS_FAILURE';
mapConstants.SET_CURRENT = 'MAP_SET_CURRENT';
mapConstants.SET_INITIALIZED = 'MAP_SET_INITIALIZED';
mapConstants.SET_TYPE = 'MAP_SET_TYPE';
mapConstants.SET_VIEW = 'MAP_SET_VIEW';
export default mapConstants;